// Hooks (@tanstack/react-query) imports
import { useMutation } from "@tanstack/react-query";

// Configs imports
import api from "../../app/api";

// Custom types imports
import { Plan } from "./types";
import { ApiErrorResponse } from "apisauce";

interface paramsType {
  data: Plan;
  notificationID: string | number;
}

export function useUpdatePlanMutation(
  onSuccessMutation?: (data: any, variables: paramsType) => void,
  onErrorMutation?: (err: ApiErrorResponse<any>, variables: paramsType) => void
) {
  async function updatePlan(params: paramsType): Promise<any> {
    const response = await api.put<any>("admin/plans", params.data);

    if (!response.ok) {
      throw response;
    }

    return response.data;
  }

  return useMutation({
    mutationFn: updatePlan,
    onSuccess: onSuccessMutation,
    onError: onErrorMutation,
  });
}
